import { render, staticRenderFns } from "./index.vue?vue&type=template&id=784b4e27&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=784b4e27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784b4e27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('784b4e27')) {
      api.createRecord('784b4e27', component.options)
    } else {
      api.reload('784b4e27', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=784b4e27&scoped=true&", function () {
      api.rerender('784b4e27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/views/reporting/index.vue"
export default component.exports